import styled from 'styled-components';

export const Row = styled.div`
	display: flex;
	gap: 6px;
`;

export const Hint = styled.div`
	font-size: 11px;
	font-weight: 400;
	color: ${({ theme }) => theme.gray[600]};
	font-style: italic;
	text-align: center;
`;
